<template>
  <list-table
    :url="url"
    title="تسویه های تسهیم انجام شده"
    :fields="fields"
    :params="params"
    :detailUrl="detailUrl"
    :excelroute="'asdasd'"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
import persianDate from "@/helpers/persianDate";
export default {
  name: "sharing",
  data() {
    return {
      url: "sharing?status=success",
      transactions_created_at:'',
      params: [
        {
          label: "موجودی بانک سامان (ریال) :",
          field: "BalanceSaman",
          type: "text",
          value:"",
          disabled: true,
        },
        {
          label: "موجودی بانک سامان 2 (ریال) :",
          field: "BalanceSaman2",
          type: "text",
          value:"",
          disabled: true,
        },
        {
          label: "موجودی بانک صادرات (ریال) :",
          field: "BalanceSaderat",
          type: "text",
          value:"",
          disabled: true,
        },
        {
          label: "از تاریخ :",
          field: "datefrom",
          type: "date-picker"
        },
        {
          label: "تا تاریخ:",
          field: "dateto",
          type: "date-picker"
        },
        {
          label: "نام مشتری :",
          field: "user_name",
          type: "text"
        },
        {
          label: "مبلغ (ریال) :",
          field: "amount",
          type: "number"
        },
        
      ],
      fields: [
        {
          key: "id",
          label: "#",
        },
        {
          key: "website",
          label: "وب سایت", 
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "created_at",
          label: "تاریخ تسهیم",
          formatter: (value, key, item) => {
            return persianDate.getDate(value);
          },
        },
        {
          key: "transactions_created_at",
          label: "تاریخ تسویه",
          formatter: (value, key, item) => {
            if(item.saderat_transactions_created_at!==null){
              return persianDate.getDate(item.saderat_transactions_created_at)
            }else if(item.saman_transactions_created_at!==null){
             return persianDate.getDate(item.saman_transactions_created_at)
            }else{
              return "...";
            } 
          },  
        },      
        {
          key: "status",
          label: "وضعیت",
          formatter: (value, key, item) => {
            if (item.parent_id === null ) {
              return "تسویه نشده";
            } else if(item.transferStatus !== null  && item.transferStatus === "ready_to_transfer"){
                            return "درخواست برای بانک ارسال شده";
            }else if( (item.transferStatus !== null && item.transferStatus === "processed") || (item.transaction_status !== null && item.transaction_status === 'success')){
              return "انجام شده";
            }else{
              return "لغو شده";
            }
          },
        },
        {
          key: "referenceId",
          label: "کد رهگیری",
          formatter: (value, key, item) => {
            if (item.referenceId !== null) {
              return item.referenceId;
            } else if (item.trace_number !== null) {
              return item.trace_number;
            }else{
              return "...";
            }
          },
        },
        {
          key: "bank_name",
          label: "نام بانک",
          formatter: (value, key, item) => {
            if (item.trace_number !== null) {
              return "صادرات";
            } else if (item.version === 1) {
              return "سامان 1";
            } else if (item.version === 2) {
              return "سامان 2";
            }else{
              return "...";
            }
          },
        },
        {
          key: "details",
          label: "عملیات",
        },
      ],
      detailUrl: "SharingDetails",
    };
  },
  components: {
    "list-table": TableShowData,
  },
  computed: {
    
  },
  methods: {
    loadedBalanceSam() {
     
      httpHelper.getData("sharing/get_balance/Saman").then((res) => {
         
          if(res.success)
        this.params[0].value = Number(res.result.balance).toLocaleString();
            else
            this.params[0].value=0;
      });
      httpHelper.getData("sharing/get_balance/Saman2").then((res) => {
        
          if(res.success)
        this.params[1].value = Number(res.result.balance).toLocaleString();
          else
            this.params[0].value=0;
      });
      httpHelper.getData("sharing/get_balance/Saderat").then((res) => {
         
          if(res.success)
        this.params[2].value = Number(res.result.balance).toLocaleString() ;
          else
            this.params[0].value=0;
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست تسویه های تسهیم انجام شده" }]);
    this.loadedBalanceSam();
  },
};
</script>